import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "p-6 space-y-6" }
const _hoisted_4 = { class: "p-6" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 items-end" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { value: "" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { value: "" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "flex items-end" }
const _hoisted_17 = { class: "relative group" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "mt-4 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_20 = {
  key: 1,
  class: "mt-4 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_21 = {
  key: 2,
  class: "mt-4 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_22 = { class: "flex items-center gap-2" }
const _hoisted_23 = { class: "flex items-start gap-4" }
const _hoisted_24 = { class: "flex-1" }
const _hoisted_25 = { class: "font-medium" }
const _hoisted_26 = { class: "mt-6 flex justify-end gap-3" }
const _hoisted_27 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "p-12 flex items-center justify-center"
}
const _hoisted_30 = { class: "flex items-center gap-3" }
const _hoisted_31 = {
  key: 1,
  class: "p-8 text-center"
}
const _hoisted_32 = { class: "text-red-600 dark:text-red-400" }
const _hoisted_33 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_34 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_35 = { class: "grid grid-cols-2 md:grid-cols-5 gap-4" }
const _hoisted_36 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "px-6 py-4" }
const _hoisted_39 = { class: "px-6 py-4" }
const _hoisted_40 = { class: "flex flex-wrap justify-center gap-1" }
const _hoisted_41 = { class: "px-6 py-4 text-center" }
const _hoisted_42 = {
  colspan: "8",
  class: "px-6 py-4"
}
const _hoisted_43 = { class: "ml-10" }
const _hoisted_44 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_45 = { class: "flex items-center justify-between mb-2" }
const _hoisted_46 = ["title"]
const _hoisted_47 = { class: "mt-2 h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" }
const _hoisted_48 = {
  key: 3,
  class: "p-12 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-4'
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", {
            class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900', 'text-2xl font-bold'])
          }, " MongoDB Index Usage ", 2),
          _createElementVNode("p", {
            class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'mt-1 text-sm'])
          }, " Monitor index performance across clusters and collections ", 2)
        ]),
        _createVNode(_component_router_link, {
          to: "/database",
          class: _normalizeClass([
            _ctx.theme.isDark.value
              ? 'text-gray-400 hover:text-gray-200'
              : 'text-gray-600 hover:text-gray-900',
            'text-sm font-medium'
          ])
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode(" ← Back to Database ")
          ])),
          _: 1,
          __: [17]
        }, 8, ["class"])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass([
          _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg overflow-hidden'
        ])
      }, [
        _createElementVNode("h2", {
          class: _normalizeClass([
            _ctx.theme.isDark.value ? 'text-gray-100 border-gray-700' : 'text-gray-900 border-gray-200',
            'text-lg font-semibold px-6 py-4 border-b'
          ])
        }, " Select Collection ", 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("label", {
                for: "mongo-env-select",
                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                  'block text-sm font-medium mb-2'
                ])
              }, " Environment ", 2),
              _withDirectives(_createElementVNode("select", {
                id: "mongo-env-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mongoEnv) = $event)),
                disabled: _ctx.clustersLoading,
                class: _normalizeClass([
                  _ctx.theme.isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-100'
                    : 'bg-white border-gray-300 text-gray-900',
                  'w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50'
                ]),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onEnvChange && _ctx.onEnvChange(...args)))
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("option", { value: "staging" }, "Staging", -1),
                _createElementVNode("option", { value: "production" }, "Production", -1)
              ]), 42, _hoisted_6), [
                [_vModelSelect, _ctx.mongoEnv]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", {
                for: "mongo-cluster-select",
                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                  'block text-sm font-medium mb-2'
                ])
              }, " Cluster ", 2),
              _withDirectives(_createElementVNode("select", {
                id: "mongo-cluster-select",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedClusterName) = $event)),
                disabled: _ctx.clustersLoading || _ctx.clusterList.length === 0,
                class: _normalizeClass([
                  _ctx.theme.isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-100'
                    : 'bg-white border-gray-300 text-gray-900',
                  'w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50'
                ])
              }, [
                _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.clustersLoading ? 'Loading...' : 'Select a cluster'), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clusterList, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: c.id,
                    value: c.name
                  }, _toDisplayString(c.name), 9, _hoisted_9))
                }), 128))
              ], 10, _hoisted_7), [
                [_vModelSelect, _ctx.selectedClusterName]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", {
                for: "mongo-db-select",
                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                  'block text-sm font-medium mb-2'
                ])
              }, " Database ", 2),
              _withDirectives(_createElementVNode("select", {
                id: "mongo-db-select",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDatabase) = $event)),
                disabled: _ctx.databasesLoading || _ctx.databases.length === 0,
                class: _normalizeClass([
                  _ctx.theme.isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-100'
                    : 'bg-white border-gray-300 text-gray-900',
                  'w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50'
                ])
              }, [
                _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.databasesLoading
                      ? 'Loading...'
                      : _ctx.selectedClusterName
                        ? 'Select a database'
                        : 'Select cluster first'), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.databases, (db) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: db,
                    value: db
                  }, _toDisplayString(db), 9, _hoisted_12))
                }), 128))
              ], 10, _hoisted_10), [
                [_vModelSelect, _ctx.selectedDatabase]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", {
                for: "mongo-collection-select",
                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                  'block text-sm font-medium mb-2'
                ])
              }, " Collection ", 2),
              _withDirectives(_createElementVNode("select", {
                id: "mongo-collection-select",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCollection) = $event)),
                disabled: _ctx.collectionsLoading || _ctx.collections.length === 0,
                class: _normalizeClass([
                  _ctx.theme.isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-100'
                    : 'bg-white border-gray-300 text-gray-900',
                  'w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50'
                ])
              }, [
                _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.collectionsLoading
                      ? 'Loading...'
                      : _ctx.selectedDatabase
                        ? 'Select a collection'
                        : 'Select database first'), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections, (col) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: col.name,
                    value: col.name
                  }, _toDisplayString(col.name), 9, _hoisted_15))
                }), 128))
              ], 10, _hoisted_13), [
                [_vModelSelect, _ctx.selectedCollection]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  disabled: _ctx.cacheClearing || !_ctx.selectedClusterName || _ctx.databases.length === 0,
                  class: _normalizeClass([
                    _ctx.theme.isDark.value
                      ? 'bg-amber-600 hover:bg-amber-700 text-white'
                      : 'bg-amber-500 hover:bg-amber-600 text-white',
                    'p-2.5 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed'
                  ]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showClearCacheConfirm = true))
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([_ctx.cacheClearing ? 'animate-spin' : '', 'w-5 h-5']),
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    viewBox: "0 0 24 24"
                  }, _cache[19] || (_cache[19] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    }, null, -1)
                  ]), 2))
                ], 10, _hoisted_18),
                _createElementVNode("div", {
                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'bg-gray-700 text-gray-200' : 'bg-gray-900 text-white',
                    'absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 rounded-md text-xs font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10'
                  ])
                }, [
                  _cache[20] || (_cache[20] = _createTextVNode(" Refresh dropdown caches for the selected cluster ")),
                  _createElementVNode("div", {
                    class: _normalizeClass([
                      _ctx.theme.isDark.value ? 'border-t-gray-700' : 'border-t-gray-900',
                      'absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent'
                    ])
                  }, null, 2)
                ], 2)
              ])
            ])
          ]),
          (_ctx.clustersError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.clustersError), 1))
            : _createCommentVNode("", true),
          (_ctx.databasesError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.databasesError), 1))
            : _createCommentVNode("", true),
          (_ctx.collectionsError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.collectionsError), 1))
            : _createCommentVNode("", true),
          (_ctx.cacheClearResult)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass([
              _ctx.theme.isDark.value
                ? 'bg-green-900/30 border-green-700'
                : 'bg-green-50 border-green-200',
              'mt-4 border rounded-lg p-3 flex items-center justify-between'
            ])
              }, [
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([_ctx.theme.isDark.value ? 'text-green-400' : 'text-green-600', 'w-5 h-5']),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, _cache[21] || (_cache[21] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    }, null, -1)
                  ]), 2)),
                  _createElementVNode("span", {
                    class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-green-300' : 'text-green-800',
                  'text-sm font-medium'
                ])
                  }, " Cache cleared successfully. Cleared " + _toDisplayString(_ctx.cacheClearResult.total) + " entries. ", 3)
                ]),
                _createElementVNode("button", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value
                  ? 'text-green-400 hover:text-green-200'
                  : 'text-green-600 hover:text-green-800'
              ]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cacheClearResult = null))
                }, _cache[22] || (_cache[22] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]), 2)
              ], 2))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (_ctx.showClearCacheConfirm)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-50 flex items-center justify-center bg-black/50",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.showClearCacheConfirm = false), ["self"]))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([
            _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
            'border rounded-lg shadow-xl max-w-md w-full mx-4 p-6'
          ])
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value
                  ? 'bg-amber-900/50 text-amber-300'
                  : 'bg-amber-100 text-amber-600',
                'p-2 rounded-lg'
              ])
                }, _cache[23] || (_cache[23] = [
                  _createElementVNode("svg", {
                    class: "w-6 h-6",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    })
                  ], -1)
                ]), 2),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h3", {
                    class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                  'text-lg font-semibold'
                ])
                  }, " Refresh Dropdown Caches ", 2),
                  _createElementVNode("p", {
                    class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'mt-2 text-sm'])
                  }, [
                    _cache[24] || (_cache[24] = _createTextVNode(" This will clear all cached data for ")),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.selectedClusterName), 1),
                    _cache[25] || (_cache[25] = _createTextVNode(" including databases and collections. "))
                  ], 2),
                  _createElementVNode("p", {
                    class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'mt-2 text-sm'])
                  }, " The dropdowns will be refreshed with fresh data from MongoDB Atlas. ", 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value
                  ? 'bg-gray-700 hover:bg-gray-600 text-gray-200'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700',
                'px-4 py-2 rounded-md text-sm font-medium transition-colors'
              ]),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showClearCacheConfirm = false))
                }, " Cancel ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value
                  ? 'bg-amber-600 hover:bg-amber-700 text-white'
                  : 'bg-amber-500 hover:bg-amber-600 text-white',
                'px-4 py-2 rounded-md text-sm font-medium transition-colors'
              ]),
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearCache && _ctx.clearCache(...args)))
                }, " Yes, Refresh Cache ", 2)
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedCollection)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg overflow-hidden'
        ])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([
            _ctx.theme.isDark.value ? 'border-gray-700' : 'border-gray-200',
            'px-6 py-4 border-b flex flex-col md:flex-row md:items-center md:justify-between gap-4'
          ])
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                'text-lg font-semibold'
              ])
                }, " Index Usage ", 2),
                _createElementVNode("p", {
                  class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'text-sm mt-1'])
                }, _toDisplayString(_ctx.selectedClusterName) + " / " + _toDisplayString(_ctx.selectedDatabase) + " / " + _toDisplayString(_ctx.selectedCollection), 3)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                'flex items-center gap-2 text-sm cursor-pointer'
              ])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showOnlyTTL) = $event)),
                    type: "checkbox",
                    class: "rounded border-gray-300 text-purple-600 focus:ring-purple-500"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.showOnlyTTL]
                  ]),
                  _cache[26] || (_cache[26] = _createTextVNode(" TTL "))
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                'flex items-center gap-2 text-sm cursor-pointer'
              ])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showOnlyUnique) = $event)),
                    type: "checkbox",
                    class: "rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.showOnlyUnique]
                  ]),
                  _cache[27] || (_cache[27] = _createTextVNode(" Unique "))
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                'flex items-center gap-2 text-sm cursor-pointer'
              ])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showOnlyCompound) = $event)),
                    type: "checkbox",
                    class: "rounded border-gray-300 text-cyan-600 focus:ring-cyan-500"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.showOnlyCompound]
                  ]),
                  _cache[28] || (_cache[28] = _createTextVNode(" Compound "))
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass([
                _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                'flex items-center gap-2 text-sm cursor-pointer'
              ])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showOnlyZeroOps) = $event)),
                    type: "checkbox",
                    class: "rounded border-gray-300 text-amber-600 focus:ring-amber-500"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.showOnlyZeroOps]
                  ]),
                  _cache[29] || (_cache[29] = _createTextVNode(" Zero ops "))
                ], 2),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.sortBy) = $event)),
                  class: _normalizeClass([
                _ctx.theme.isDark.value
                  ? 'bg-gray-700 border-gray-600 text-gray-100'
                  : 'bg-white border-gray-300 text-gray-900',
                'rounded-md border px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500'
              ])
                }, _cache[30] || (_cache[30] = [
                  _createStaticVNode("<option value=\"name-asc\">Name A-Z</option><option value=\"name-desc\">Name Z-A</option><option value=\"ops-asc\">Ops (Low to High)</option><option value=\"ops-desc\">Ops (High to Low)</option><option value=\"size-asc\">Size (Small to Large)</option><option value=\"size-desc\">Size (Large to Small)</option>", 6)
                ]), 2), [
                  [_vModelSelect, _ctx.sortBy]
                ]),
                _createElementVNode("button", {
                  disabled: _ctx.indexUsageLoading,
                  class: _normalizeClass([
                _ctx.theme.isDark.value
                  ? 'bg-blue-600 hover:bg-blue-700 text-white'
                  : 'bg-blue-600 hover:bg-blue-700 text-white',
                'px-4 py-1.5 rounded-md text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
              ]),
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.loadIndexUsage && _ctx.loadIndexUsage(...args)))
                }, _toDisplayString(_ctx.indexUsageLoading ? 'Loading...' : 'Refresh'), 11, _hoisted_28)
              ])
            ], 2),
            (_ctx.indexUsageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[31] || (_cache[31] = _createElementVNode("svg", {
                      class: "animate-spin h-5 w-5 text-blue-500",
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      })
                    ], -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600')
                    }, " Loading index usage data... ", 2)
                  ])
                ]))
              : (_ctx.indexUsageError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.indexUsageError), 1),
                    _createElementVNode("button", {
                      class: "mt-4 px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.loadIndexUsage && _ctx.loadIndexUsage(...args)))
                    }, " Retry ")
                  ]))
                : (_ctx.filteredIndexes.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      (_ctx.collectionStats)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([
              _ctx.theme.isDark.value
                ? 'bg-gradient-to-r from-blue-900/30 to-indigo-900/30 border-blue-800'
                : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200',
              'px-6 py-4 border-b'
            ])
                          }, [
                            _createElementVNode("div", _hoisted_34, [
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass([_ctx.theme.isDark.value ? 'text-blue-400' : 'text-blue-600', 'w-5 h-5']),
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, _cache[32] || (_cache[32] = [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                                }, null, -1)
                              ]), 2)),
                              _createElementVNode("span", {
                                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-blue-300' : 'text-blue-700',
                  'text-sm font-medium'
                ])
                              }, " Collection Statistics ", 2)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", {
                                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'bg-gray-800/50' : 'bg-white/80',
                  'rounded-lg px-4 py-3'
                ])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                    'text-xs uppercase tracking-wider'
                  ])
                                }, " Documents ", 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                    'text-lg font-semibold mt-1'
                  ])
                                }, _toDisplayString(_ctx.collectionStats.count.toLocaleString()), 3)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'bg-gray-800/50' : 'bg-white/80',
                  'rounded-lg px-4 py-3'
                ])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                    'text-xs uppercase tracking-wider'
                  ])
                                }, " Data Size ", 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                    'text-lg font-semibold mt-1'
                  ])
                                }, _toDisplayString(_ctx.formatBytes(_ctx.collectionStats.sizeBytes)), 3)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'bg-gray-800/50' : 'bg-white/80',
                  'rounded-lg px-4 py-3'
                ])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                    'text-xs uppercase tracking-wider'
                  ])
                                }, " Avg Doc Size ", 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                    'text-lg font-semibold mt-1'
                  ])
                                }, _toDisplayString(_ctx.formatBytes(_ctx.collectionStats.avgObjSize)), 3)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'bg-gray-800/50' : 'bg-white/80',
                  'rounded-lg px-4 py-3'
                ])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                    'text-xs uppercase tracking-wider'
                  ])
                                }, " Storage Size ", 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                    'text-lg font-semibold mt-1'
                  ])
                                }, _toDisplayString(_ctx.formatBytes(_ctx.collectionStats.storageSizeBytes)), 3)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'bg-gray-800/50' : 'bg-white/80',
                  'rounded-lg px-4 py-3'
                ])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-indigo-400' : 'text-indigo-600',
                    'text-xs uppercase tracking-wider'
                  ])
                                }, " Total Index Size ", 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-indigo-300' : 'text-indigo-700',
                    'text-lg font-semibold mt-1'
                  ])
                                }, _toDisplayString(_ctx.formatBytes(_ctx.collectionStats.totalIndexSizeBytes)), 3)
                              ], 2)
                            ])
                          ], 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass([
              _ctx.theme.isDark.value ? 'bg-gray-700/30 border-gray-700' : 'bg-gray-50 border-gray-200',
              'px-6 py-3 border-b grid grid-cols-3 md:grid-cols-6 gap-4'
            ])
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " Total ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.indexes.length), 3)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " Zero Ops ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.zeroOpsCount > 0
                    ? 'text-amber-500'
                    : _ctx.theme.isDark.value
                      ? 'text-gray-100'
                      : 'text-gray-900',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.zeroOpsCount), 3)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-purple-400' : 'text-purple-600',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " TTL ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-purple-300' : 'text-purple-700',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.ttlIndexCount), 3)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-blue-400' : 'text-blue-600',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " Unique ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-blue-300' : 'text-blue-700',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.uniqueIndexCount), 3)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-cyan-400' : 'text-cyan-600',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " Compound ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-cyan-300' : 'text-cyan-700',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.compoundIndexCount), 3)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                  'text-xs uppercase tracking-wider'
                ])
                          }, " Showing ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                  'text-xl font-semibold mt-1'
                ])
                          }, _toDisplayString(_ctx.filteredIndexes.length), 3)
                        ])
                      ], 2),
                      _createElementVNode("table", _hoisted_36, [
                        _createElementVNode("thead", {
                          class: _normalizeClass([
                _ctx.theme.isDark.value ? 'bg-gray-700/50' : 'bg-gray-50',
                'text-left text-xs font-medium uppercase tracking-wider'
              ])
                        }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600', 'px-6 py-3 w-8'])
                            }, null, 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600', 'px-6 py-3'])
                            }, " Index Name ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600', 'px-6 py-3'])
                            }, " Key Definition ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600',
                    'px-6 py-3 text-right'
                  ])
                            }, " Total Ops ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600', 'px-6 py-3'])
                            }, " Since ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600',
                    'px-6 py-3 text-center'
                  ])
                            }, " Type ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600',
                    'px-6 py-3 text-right'
                  ])
                            }, " Size ", 2),
                            _createElementVNode("th", {
                              class: _normalizeClass([
                    _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600',
                    'px-6 py-3 text-center'
                  ])
                            }, " Status ", 2)
                          ])
                        ], 2),
                        _createElementVNode("tbody", {
                          class: _normalizeClass([_ctx.theme.isDark.value ? 'divide-gray-700' : 'divide-gray-200', 'divide-y'])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredIndexes, (idx, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: idx.name
                            }, [
                              _createElementVNode("tr", {
                                class: _normalizeClass([
                    _ctx.theme.isDark.value
                      ? 'bg-gray-800 hover:bg-gray-700/50'
                      : 'bg-white hover:bg-gray-50',
                    'cursor-pointer transition-colors'
                  ]),
                                onClick: ($event: any) => (_ctx.toggleRow(i))
                              }, [
                                _createElementVNode("td", _hoisted_38, [
                                  (_openBlock(), _createElementBlock("svg", {
                                    class: _normalizeClass([
                        _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                        'w-4 h-4 transition-transform',
                        _ctx.expandedRows.includes(i) ? 'rotate-90' : ''
                      ]),
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, _cache[33] || (_cache[33] = [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M9 5l7 7-7 7"
                                    }, null, -1)
                                  ]), 2))
                                ]),
                                _createElementVNode("td", {
                                  class: _normalizeClass([
                      _ctx.theme.isDark.value ? 'text-gray-200' : 'text-gray-900',
                      'px-6 py-4 text-sm font-medium'
                    ])
                                }, _toDisplayString(idx.name), 3),
                                _createElementVNode("td", {
                                  class: _normalizeClass([
                      _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600',
                      'px-6 py-4 text-sm font-mono text-xs'
                    ])
                                }, _toDisplayString(_ctx.formatKey(idx.key)), 3),
                                _createElementVNode("td", {
                                  class: _normalizeClass([
                      idx.usage.ops === 0
                        ? 'text-amber-500'
                        : _ctx.theme.isDark.value
                          ? 'text-gray-100'
                          : 'text-gray-900',
                      'px-6 py-4 text-sm font-semibold text-right'
                    ])
                                }, _toDisplayString(idx.usage.ops.toLocaleString()), 3),
                                _createElementVNode("td", {
                                  class: _normalizeClass([
                      _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                      'px-6 py-4 text-sm'
                    ])
                                }, _toDisplayString(_ctx.formatDate(idx.usage.since)), 3),
                                _createElementVNode("td", _hoisted_39, [
                                  _createElementVNode("div", _hoisted_40, [
                                    (idx.ttlSeconds)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass([
                          _ctx.theme.isDark.value
                            ? 'bg-purple-900/50 text-purple-300'
                            : 'bg-purple-100 text-purple-800',
                          'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'
                        ])
                                        }, " TTL " + _toDisplayString(_ctx.formatTTL(idx.ttlSeconds)), 3))
                                      : _createCommentVNode("", true),
                                    (_ctx.isUniqueIndex(idx))
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: _normalizeClass([
                          _ctx.theme.isDark.value
                            ? 'bg-blue-900/50 text-blue-300'
                            : 'bg-blue-100 text-blue-800',
                          'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'
                        ])
                                        }, " Unique ", 2))
                                      : _createCommentVNode("", true),
                                    (Object.keys(idx.key).length > 1)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 2,
                                          class: _normalizeClass([
                          _ctx.theme.isDark.value
                            ? 'bg-cyan-900/50 text-cyan-300'
                            : 'bg-cyan-100 text-cyan-800',
                          'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'
                        ])
                                        }, " Compound (" + _toDisplayString(Object.keys(idx.key).length) + ") ", 3))
                                      : _createCommentVNode("", true),
                                    (
                          !idx.ttlSeconds &&
                          !_ctx.isUniqueIndex(idx) &&
                          Object.keys(idx.key).length === 1
                        )
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 3,
                                          class: _normalizeClass([
                          _ctx.theme.isDark.value
                            ? 'bg-gray-700 text-gray-300'
                            : 'bg-gray-100 text-gray-700',
                          'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'
                        ])
                                        }, " Standard ", 2))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("td", {
                                  class: _normalizeClass([
                      _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-600',
                      'px-6 py-4 text-right text-sm'
                    ])
                                }, _toDisplayString(idx.sizeBytes ? _ctx.formatBytes(idx.sizeBytes) : '-'), 3),
                                _createElementVNode("td", _hoisted_41, [
                                  (_ctx.isUnusedIndex(idx))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass([
                        _ctx.theme.isDark.value
                          ? 'bg-amber-900/50 text-amber-300'
                          : 'bg-amber-100 text-amber-800',
                        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'
                      ])
                                      }, " Unused ", 2))
                                    : (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        class: _normalizeClass([
                        _ctx.theme.isDark.value
                          ? 'bg-green-900/50 text-green-300'
                          : 'bg-green-100 text-green-800',
                        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'
                      ])
                                      }, " Active ", 2))
                                ])
                              ], 10, _hoisted_37),
                              (_ctx.expandedRows.includes(i))
                                ? (_openBlock(), _createElementBlock("tr", {
                                    key: 0,
                                    class: _normalizeClass([_ctx.theme.isDark.value ? 'bg-gray-900' : 'bg-gray-50'])
                                  }, [
                                    _createElementVNode("td", _hoisted_42, [
                                      _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("h4", {
                                          class: _normalizeClass([
                          _ctx.theme.isDark.value ? 'text-gray-300' : 'text-gray-700',
                          'text-sm font-medium mb-3'
                        ])
                                        }, " Per-Host Usage Breakdown ", 2),
                                        _createElementVNode("div", _hoisted_44, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(idx.usage.perHost, (host) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: host.host,
                                              class: _normalizeClass([
                            _ctx.theme.isDark.value
                              ? 'bg-gray-800 border-gray-700'
                              : 'bg-white border-gray-200',
                            'border rounded-lg p-4'
                          ])
                                            }, [
                                              _createElementVNode("div", _hoisted_45, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass([
                                _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-500',
                                'text-xs font-mono truncate max-w-[200px]'
                              ]),
                                                  title: host.host
                                                }, _toDisplayString(_ctx.truncateHost(host.host)), 11, _hoisted_46),
                                                _createElementVNode("span", {
                                                  class: _normalizeClass([
                                host.ops === 0
                                  ? 'text-amber-500'
                                  : _ctx.theme.isDark.value
                                    ? 'text-gray-100'
                                    : 'text-gray-900',
                                'text-sm font-semibold'
                              ])
                                                }, _toDisplayString(host.ops.toLocaleString()) + " ops ", 3)
                                              ]),
                                              _createElementVNode("div", {
                                                class: _normalizeClass([
                              _ctx.theme.isDark.value ? 'text-gray-500' : 'text-gray-400',
                              'text-xs'
                            ])
                                              }, " Since " + _toDisplayString(_ctx.formatDate(host.since)), 3),
                                              _createElementVNode("div", _hoisted_47, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass([[host.ops === 0 ? 'bg-amber-500' : 'bg-green-500'], "h-full transition-all duration-300"]),
                                                  style: _normalizeStyle({ width: _ctx.getOpsBarWidth(host.ops, idx.usage.perHost) })
                                                }, null, 6)
                                              ])
                                            ], 2))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ], 2))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 2)
                      ])
                    ]))
                  : (!_ctx.indexUsageLoading && !_ctx.indexUsageError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-gray-600' : 'text-gray-400',
              'w-12 h-12 mx-auto mb-4'
            ]),
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, _cache[34] || (_cache[34] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          }, null, -1)
                        ]), 2)),
                        _createElementVNode("p", {
                          class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'text-sm'])
                        }, _toDisplayString(_ctx.showOnlyTTL || _ctx.showOnlyUnique || _ctx.showOnlyCompound || _ctx.showOnlyZeroOps
                ? 'No indexes match the current filters'
                : 'No indexes found for this collection'), 3)
                      ]))
                    : _createCommentVNode("", true)
          ], 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass([
          _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-12 text-center'
        ])
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([
            _ctx.theme.isDark.value ? 'text-gray-600' : 'text-gray-400',
            'w-16 h-16 mx-auto mb-4'
          ]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, _cache[35] || (_cache[35] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
              }, null, -1)
            ]), 2)),
            _createElementVNode("h3", {
              class: _normalizeClass([
            _ctx.theme.isDark.value ? 'text-gray-200' : 'text-gray-900',
            'text-lg font-medium mb-2'
          ])
            }, " Select a Collection ", 2),
            _createElementVNode("p", {
              class: _normalizeClass([_ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'text-sm'])
            }, " Choose an environment, cluster, database, and collection above to view index usage statistics. ", 2)
          ], 2))
    ])
  ]))
}